import { PageType, RouteProps } from "@/types/types";
import { ParsedUrlQuery } from "querystring";

export type PageQueryParams = {
  searchTerm?: string;
  sortBy?: string;
  page?: string;
  facet?: string;
  cardType?: string;
  listHead?: string;
  lolcode?: string;
  price?: string;
  priceBands?: string;
  pageSize?: string;
  from?: string;
  // Include any other query parameters that might be present
  [key: string]: string | string[] | undefined;
};

export function buildPageQueryParams(query: ParsedUrlQuery): PageQueryParams {
  const { type: _, facetId: __, ...restOfQuery } = query;

  function extractFirstValue(
    param: string | string[] | undefined,
  ): string | undefined {
    return Array.isArray(param) ? param[0] : param;
  }

  const queryParams: PageQueryParams = {
    ...restOfQuery,
    searchTerm: extractFirstValue(restOfQuery["search-term"]),
    sortBy: extractFirstValue(restOfQuery.sortBy),
    page: extractFirstValue(restOfQuery.page) || "1",
    facet: extractFirstValue(restOfQuery.facet),
    cardType: extractFirstValue(restOfQuery.cardType),
    listHead: extractFirstValue(restOfQuery.listHead),
    lolcode: extractFirstValue(restOfQuery.lolcode),
    price: extractFirstValue(restOfQuery.price),
    priceBands: extractFirstValue(restOfQuery.priceBands),
    pageSize: extractFirstValue(restOfQuery.pageSize),
    from: extractFirstValue(restOfQuery.from),
  };

  delete queryParams["search-term"];
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] === undefined) {
      delete queryParams[key];
    }
  });

  return queryParams;
}

export function getPageType(query: ParsedUrlQuery): PageType | undefined {
  const { type } = query;

  const typeIsValid =
    type === "search" || type === "brand" || type === "browse";

  if (!typeIsValid) {
    return undefined;
  }

  return type;
}

export function getFacetId(query: ParsedUrlQuery): RouteProps["facetId"] {
  const { facetId } = query;
  if (!facetId) return null;
  if (typeof facetId === "string") return [facetId];
  return facetId;
}

export function getRouteProps(query: ParsedUrlQuery): RouteProps | undefined {
  const pageType = getPageType(query);
  if (!pageType) return undefined;

  const pageQueryParams = buildPageQueryParams(query);
  const facetId = getFacetId(query);

  return {
    query: pageQueryParams,
    facetId,
    pageType,
  };
}
